/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { forwardRef, useEffect } from "react";
import PropTypes from "prop-types";

/* eslint-disable react/display-name */
const ErrorBox = forwardRef(({ errorMessage = "" }, ref) => {
  useEffect(() => {
    if (ref?.current) {
      ref.current.focus();
    }
  }, [ref]);

  if (errorMessage) {
    return (
      <div className='error-box' role='alert' tabIndex='0' ref={ref}>
        {/* eslint-disable-next-line react/no-danger */}
        <p
          className='error-box-text'
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      </div>
    );
  }

  return null;
});

ErrorBox.propTypes = {
  errorMessage: PropTypes.string
};

export default ErrorBox;
